import {
    // icons
    IconChartArea,
    IconUsers,
    IconMoneyBills,
    IconGlobe,
    IconLanguage,
    IconEnvelope,
    IconPercent,
    IconTableColumns,
    IconTriangleExclamation,

    // route names
    GENERAL_ROUTE_NAMES,
    DIRECTOR_ROUTE_NAMES,
    PAYMENTS_ROUTE_NAMES,
    TRANSLATIONS_ROUTE_NAMES,
    LANGUAGES_ROUTE_NAMES,
    MAILING_ROUTE_NAMES,
    PROMOCODES_ROUTE_NAMES,
    CRM_ROUTE_NAMES,
    ISSUES_ROUTE_NAMES,
} from "@/shared";

export default {
    MENU_A_DASHBOARD: {
        icon: IconChartArea,
        title: "Аналитика",
        to: { name: GENERAL_ROUTE_NAMES.DASHBOARD },
        activeRoutes: { DASHBOARD: GENERAL_ROUTE_NAMES.DASHBOARD },
    },
    MENU_A_DIRECTORS: {
        icon: IconUsers,
        title: "Директора",
        to: { name: DIRECTOR_ROUTE_NAMES.LIST },
        activeRoutes: DIRECTOR_ROUTE_NAMES,
    },
    MENU_A_CRM: {
        icon: IconTableColumns,
        title: "CRM",
        to: { name: CRM_ROUTE_NAMES.BOARD },
        activeRoutes: CRM_ROUTE_NAMES,
    },
    MENU_A_ISSUES: {
        icon: IconTriangleExclamation,
        title: "Проблемы",
        to: { name: ISSUES_ROUTE_NAMES.LIST },
        activeRoutes: ISSUES_ROUTE_NAMES,
    },
    MENU_A_PAYMENTS: {
        icon: IconMoneyBills,
        title: "Платежи",
        to: { name: PAYMENTS_ROUTE_NAMES.LIST },
        activeRoutes: PAYMENTS_ROUTE_NAMES,
    },
    MENU_A_MAILING: {
        icon: IconEnvelope,
        title: "Рассылки",
        to: { name: MAILING_ROUTE_NAMES.LIST },
        activeRoutes: MAILING_ROUTE_NAMES,
    },
    MENU_A_TRANSLATIONS: {
        icon: IconGlobe,
        title: "Переводы",
        to: { name: TRANSLATIONS_ROUTE_NAMES.LIST },
        activeRoutes: {
            LIST: TRANSLATIONS_ROUTE_NAMES.LIST,
            CREATE: TRANSLATIONS_ROUTE_NAMES.CREATE,
            EDIT: TRANSLATIONS_ROUTE_NAMES.EDIT,
        },
    },
    MENU_A_LANGUAGES: {
        icon: IconLanguage,
        title: "Языки",
        to: { name: LANGUAGES_ROUTE_NAMES.LIST },
        activeRoutes: {
            LIST: LANGUAGES_ROUTE_NAMES.LIST,
            CREATE: LANGUAGES_ROUTE_NAMES.CREATE,
            EDIT: LANGUAGES_ROUTE_NAMES.EDIT,
        },
    },
    MENU_A_PROMOCODES: {
        icon: IconPercent,
        title: "Промокоды",
        to: { name: PROMOCODES_ROUTE_NAMES.LIST },
        activeRoutes: {
            LIST: PROMOCODES_ROUTE_NAMES.LIST,
            CREATE: PROMOCODES_ROUTE_NAMES.CREATE,
            EDIT: PROMOCODES_ROUTE_NAMES.EDIT,
        },
    },
};
